import { BaseViewStore } from 'core/stores';
import { action, observable } from 'mobx';

class FacilityOrderNewFlowConfirmModalStore extends BaseViewStore {
	@observable accessor isLoading = false;
	constructor(rootStore, componentsProps) {
        super(rootStore);

        this.rootStore = rootStore;
        this.modalParams = componentsProps.modalParams;
        this.message = this.modalParams.data.message
        this.onConfirm = this.modalParams.data.onConfirm;
        this.cancelLabel = this.modalParams.data.cancelLabel ? this.modalParams.data.cancelLabel  : 'MODAL.CANCEL_LABEL';
        this.confirmLabel = this.modalParams.data.confirmLabel ? this.modalParams.data.confirmLabel: 'MODAL.CONFIRM_LABEL';
    }

	@action.bound
	async confirm() {
		this.isLoading = true;
		await this.onConfirm();
		this.isLoading = false;
		this.modalParams.close();
	}

}

export default FacilityOrderNewFlowConfirmModalStore;